import api from "../utils/api";

// Helper function to handle CORS errors specifically
const handleCorsError = (error) => {
    if (error?.response) {
        return null;
    }

    if (error.message === 'Network Error' || error.code === 'ERR_NETWORK') {
        return {
            error: 'Network error - please check your connection',
            isCorsError: true
        };
    }

    if (!error.response) {
        return {
            error: 'No response from server - possible CORS issue',
            isCorsError: true
        };
    }

    return null;
};

const authRequestConfig = { suppressErrorToast: true };

export const Authlogin = async (data) => {
    try {
        const response = await api.post('/auth/login', data, authRequestConfig);
        if (response.status === 200 || response.status === 206) {
            return response.data;
        }
        if (response.status === 401) {
            return {
                error: response.data?.message || 'Invalid credentials.',
                status: response.status,
            };
        }
    } catch (error) {
        const corsError = handleCorsError(error);
        if (corsError) return corsError;

        return {
            error: error.response?.data?.message || error.message,
            status: error.response?.status
        };
    }
}

export const ForgotPassword = async (data) => {
    try {
        const response = await api.post('/auth/forgot-password', data, authRequestConfig);
        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        const corsError = handleCorsError(error);
        if (corsError) return corsError;

        return {
            error: error.response?.data?.message || error.message,
            status: error.response?.status
        };
    }
}

export const ResetPasswordAPI = async (data) => {
    try {
        const response = await api.post('/auth/reset-password', data, authRequestConfig);
        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        const corsError = handleCorsError(error);
        if (corsError) return corsError;

        return {
            error: error.response?.data?.message || error.message,
            status: error.response?.status
        };
    }
}

export const actorSendOTP = async (data) => {
    try {
        const response = await api.post('/auth/send-otp', data);
        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        const corsError = handleCorsError(error);
        if (corsError) return corsError;

        return {
            error: error.response?.data?.message || error.message,
            status: error.response?.status
        };
    }
}

export const actorVerifyOTP = async (data) => {
    try {
        const response = await api.post('/auth/verify-otp', data);
        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        const corsError = handleCorsError(error);
        if (corsError) return corsError;

        return {
            error: error.response?.data?.message || error.message,
            status: error.response?.status
        };
    }
}

/** GET /auth/me/theme-preferences — optional per-user theme overlay. */
export const GetMeThemePreferences = async () => {
    try {
        const response = await api.get("/auth/me/theme-preferences");
        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        const corsError = handleCorsError(error);
        if (corsError) return corsError;

        return {
            error: error.response?.data?.message || error.message,
            status: error.response?.status,
        };
    }
};

/** PUT /auth/me/theme-preferences — set or clear (`null`) overlay. */
export const PutMeThemePreferences = async (theme_preferences) => {
    try {
        const response = await api.put("/auth/me/theme-preferences", { theme_preferences });
        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        const corsError = handleCorsError(error);
        if (corsError) return corsError;

        return {
            error: error.response?.data?.message || error.message,
            status: error.response?.status,
        };
    }
};

export const verify_account_details = async (data) => {
    try {
        const response = await api.post('/auth/fetchInvitedetails', data);
        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        const corsError = handleCorsError(error);
        if (corsError) return corsError;

        return {
            error: error.response?.data?.message || error.message,
            status: error.response?.status
        };
    }
}

export const fetchActorInvitePreview = async (token) => {
    try {
        const response = await api.get('/auth/actor-invite-preview', {
            params: { token },
        });
        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        const corsError = handleCorsError(error);
        if (corsError) return corsError;

        return {
            error: error.response?.data?.message || error.message,
            status: error.response?.status,
        };
    }
};

export const FetchTenantBootstrap = async () => {
    try {
        const response = await api.get('/auth/tenant-bootstrap');
        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        return { error: error?.response?.data?.message || error?.message };
    }
};

export const RequestSelfSignup = async (data) => {
    try {
        const response = await api.post('/auth/self-signup/request', data, authRequestConfig);
        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        const corsError = handleCorsError(error);
        if (corsError) return corsError;
        return {
            error: error.response?.data?.message || error.message,
            status: error.response?.status,
        };
    }
};

export const VerifySelfSignup = async (token) => {
    try {
        const response = await api.get('/auth/self-signup/verify', {
            params: { token },
            suppressErrorToast: true,
        });
        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        const corsError = handleCorsError(error);
        if (corsError) return corsError;
        return {
            error: error.response?.data?.message || error.message,
            status: error.response?.status,
        };
    }
};